export default {
  "fr": {
    "timestamp": {
      "labels": {
        "accepted": "Accepté {date}",
        "due": "Echéance: {date}",
        "in": "Dans {time}",
        "justNow": "Maintenant",
        "noDeadline": "Aucun délai fixé",
        "starts": "Départ: {date}",
        "today": "Aujourd'hui",
        "tomorrow": "Demain",
        "uploaded": "Téléchargé {date}",
        "yesterday": "Hier"
      }
    }
  }
}